import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m12.622 8.28-4.12 4.127a2.833 2.833 0 0 1-4-4l5.333-5.334a1.713 1.713 0 0 1 2.36 0 1.68 1.68 0 0 1 0 2.36l-4.6 4.594a.507.507 0 0 1-.72.026.51.51 0 0 1-.027-.72l3.42-3.413a.67.67 0 0 0-.946-.947L5.902 8.4a1.827 1.827 0 0 0 0 2.593 1.88 1.88 0 0 0 2.593 0l4.593-4.6a3 3 0 0 0-4.24-4.24L3.515 7.487a4.167 4.167 0 0 0 5.927 5.846l4.126-4.12a.668.668 0 0 0-.73-1.091.7.7 0 0 0-.216.145z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })